var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"margin_area"},[_c('p',{staticClass:"tit"},[_vm._v(" 请选择充值金额 "),_c('van-icon',{attrs:{"name":"cross"},on:{"click":_vm.close}})],1),_c('margin-recharge')],1)}
var staticRenderFns = []

export { render, staticRenderFns }